import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "../../components/container/MainContainer";
import {
  getCanceledProjects,
  unsetProjects,
} from "./../../features/projectsSlice";
import Loading from "../../components/loading/Loading";
import LocationHeader from "../../components/header/LocationHeader";
import Table from "../../components/tables/Table";
import loadStatus from "../../util/loadStatus";
import { useLocation } from "react-router-dom";
import NetworkError from "../error/NetworkError";
import PaginationSecondBar from "../../components/pagination/PaginationSecondBar";

const CanceledProjects = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector((state) => state.user.userInfo);
  const projects = useSelector((state) => state.projects.data);
  const total = useSelector((state) => state.projects.total);
  const loading = useSelector(
    (state) => state.projects.load.getCanceledProjects
  );

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Title" },
    { id: `status`, text: "Status" },
    { id: "community", text: "Community" },
  ];

  const onPageChange = async (limit, offset) => {
    try {
      await dispatch(
        getCanceledProjects({
          province_id: user.province_id,
          desk: "canceled",
          community_id: user.communities[0]?.id,
          limit,
          offset,
        })
      );
    } catch (error) {}
  };
  useEffect(() => {
    if (user.id) {
      dispatch(
        getCanceledProjects({
          province_id: user.province_id,
          desk: "canceled",
          community_id: user.communities[0]?.id,
        })
      );
    }
    return () => {
      dispatch(unsetProjects());
    };
  }, [user]);

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <LocationHeader title="Canceled Projects" links={[]} />
      <PaginationSecondBar
        loading={loading}
        onPageChange={onPageChange}
        total={total}
      />
      <main className="table-container">
        <Table columns={columns} data={projects} link />
      </main>
    </MainContainer>
  );
};

export default CanceledProjects;
